import * as React from 'react';

import classnames from 'classnames';
import moment from 'moment';

import type {CampaignType} from 'nutshell-graphql-types';
import type {EditionFragment as Edition} from 'nutshell-graphql-types';

import {NewPreviewBody} from './new-preview-body';
import {NewPreviewData} from './new-preview-data';
import type {SelectedRecipients} from './new-recipients-selection-view';

import styles from './new-preview-view.module.css';

type Props = {
    edition: Edition;
    scheduledDate: moment.Moment | null | undefined;
    type: CampaignType;
    selectedRecipients: SelectedRecipients | null | undefined;
    isScheduling: boolean;
};

export function NewPreviewView(props: Props) {
    return (
        <div className={classnames('full-width full-height', styles['details-container'])}>
            <div className={styles['details-container-left']}>
                <NewPreviewBody edition={props.edition} />
            </div>
            <div className={styles['details-container-right']}>
                {props.selectedRecipients ? (
                    <NewPreviewData
                        edition={props.edition}
                        scheduledDate={props.scheduledDate}
                        type={props.type}
                        isScheduling={props.isScheduling}
                        selectedRecipients={props.selectedRecipients}
                    />
                ) : undefined}
            </div>
        </div>
    );
}
